import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
// import RenderFirebase from './RenderFirebase'
import {Provider} from 'react-redux';
import {BrowserRouter} from 'react-router-dom';
import store from './reducers'


ReactDOM.render(
    <BrowserRouter>
        <Provider store={store}>
            <App/>
        </Provider>
    </BrowserRouter>
, document.getElementById('root'));


serviceWorker.unregister();
